import React from "react";
import { Link } from "react-router-dom";
import "../css/App.css";
import { isMobile } from "react-device-detect";
import { scroller } from "react-scroll";

export default function NavbarJS() {
  function aboutMe() {
    if (isMobile) {
      scroller.scrollTo("aboutMeScroll", {
        duration: 0,
        delay: 500,
        smooth: "easeOutQuad",
        offset: 80,
      });
    } else {
      scroller.scrollTo("aboutMeScroll", {
        duration: 0,
        delay: 0,
        smooth: "easeOutQuad",
        offset: 50,
      });
    }
  }

  function contactMe() {
    window.scrollTo({
      left: 0,
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  }

  return (
    <div
      className="container d-flex align-items-center mt-5 p-2"
      style={{ overflowX: "hidden" }}
    >
      <div className="home">
        <Link to="/" className="linkNormal" id="homeRoute">
          <strong id="homeRouteText">Neeleshwar's Portfolio</strong>
        </Link>
      </div>
      <div className="" style={{ marginLeft: "auto" }} id="restRoute">
        <Link to="/Work">
          <label style={{ color: "black" }}>Projects</label>
        </Link>
        <Link to="#" onClick={aboutMe}>
          <label style={{ color: "black" }}>About Me</label>
        </Link>
        <Link to="#" onClick={contactMe}>
          <label style={{ color: "black" }}>Contact</label>
        </Link>
      </div>
    </div>
  );
}
